import dayjs from 'dayjs';

export default {
  name: 'WDateTimeDisplay',
  props: {
    dateTime: {
      required: true,
      type: Object,
    },
    textBold: {
      default: false,
      type: Boolean,
    },
    textSizeClass: {
      default: 'text-sm',
      type: String,
    },
    timeTextClass: {
      default: 'font-medium text-seaweed-green-500',
      type: String,
    },
  },
  methods: {
    dayjs,
    inSameDay() {
      const { end_time: end = '', start_time: start = '' } = this.dateTime || {};
      const dayEnd = dayjs(end);
      const dayStart = dayjs(start);

      return dayStart.isSame(dayEnd, 'day');
    },
  },
};
